import { clsx } from 'clsx';

const STATUS_COLORS = {
  Won: 'bg-status-won',
  Open: 'bg-status-open',
  Lost: 'bg-status-lost',
  // Q-01 (10/1/26): the job was cancelled or not awarded (was "Dead" 9/29-10/1)
  Cancelled: 'bg-status-cancel',
  // Paul Q5: we backed out. Its own muted taupe so it never reads as Cancelled.
  'No Quote': 'bg-[#7A6A5B]',
  // kept so a stray old value still gets the right colour
  Dead: 'bg-status-cancel',
  Cancel: 'bg-status-cancel',
};

export function StatusPill({ status, className }) {
  const bg = STATUS_COLORS[status] || 'bg-status-cancel';
  return (
    <span className={clsx('inline-block text-pill text-white uppercase px-2.5 py-0.5 rounded-xs', bg, className)}>{status || '-'}</span>
  );
}
